import { render, staticRenderFns } from "./AuthorizationD4Sign.vue?vue&type=template&id=7998a442&scoped=true&"
import script from "./AuthorizationD4Sign.vue?vue&type=script&lang=js&"
export * from "./AuthorizationD4Sign.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationD4Sign.vue?vue&type=style&index=0&id=7998a442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7998a442",
  null
  
)

export default component.exports